const selectedMembershipPackageDetails = (state = null, action) => {
  if (action.type === "SET_SELECTED_MEMBERSHIP_PACKAGE_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_SELECTED_MEMBERSHIP_PACKAGE_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default selectedMembershipPackageDetails;
